if (!customElements.get('combined-listing')) {
  customElements.define('combined-listing',
    class CombinedListing extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          this.updateSelectionMetadata(event);
        });

        requestAnimationFrame(() => {
          this.selectDefaultVariant();
          this.updateSelectionMetadata({ target: this });
        });

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.syncStickyATC(), { once: true });
        }
      }

      syncStickyATC() {
        const checkedListingInput = this.querySelector('[data-combined-listing-input]:checked');
        if (!checkedListingInput) return;

        this.finalListingValue = checkedListingInput.nextElementSibling.querySelector('.js-option-value-id').value;
        this.stickyATCInfo = document.querySelector('.product__sticky-atc-info');
        this.updateStickyATC(checkedListingInput);
      }

      selectDefaultVariant() {
        const combinedListingInputs = this.querySelectorAll('[data-combined-listing-input]');
        const paramInput = Array.from(combinedListingInputs).find((input) => input.dataset.selectedParam);
        if (!paramInput) return;

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has(paramInput.dataset.selectedParam)) {
          paramInput.checked = true;
        }
      }

      updateSelectionMetadata({ target }) {
        requestAnimationFrame(() => {
          const label = target.closest('label.offer__option');
          if (label) {
            const inputId = label.getAttribute('for');
            const input = document.getElementById(inputId);
            input.checked = true;
          }

          if (target.value !== undefined) this.syncVariantSelects(target);

          this.combinedListingInput = this.querySelectorAll('[data-combined-listing-input]');
          const checkedListingInput = Array.from(this.combinedListingInput).find(input => input.checked);
          this.finalListingValue = checkedListingInput.nextElementSibling.querySelector('.js-option-value-id').value;

          const variantListenerValue = this.closest('[id*="ProductInfo-"]').querySelector('[data-id-listener]').value;
          let variantId;
          this.finalListingValue == 'currentProduct' ? variantId = variantListenerValue : variantId = this.finalListingValue;

          // let productBadges;
          // this.finalListingValue == 'currentProduct' ? productBadges = true : productBadges = false;

          const productInfo = this.closest('[id*="ProductInfo-"]');
          const individualDiscounts = productInfo.querySelectorAll('discount-copy[data-individual-only]');
          individualDiscounts.forEach(el => this.finalListingValue == 'currentProduct' ? el.classList.remove('visually-hidden') : el.classList.add('visually-hidden'));

          const listingDiscounts = productInfo.querySelectorAll('discount-copy[data-combined-listing-ids]');
          listingDiscounts.forEach(el => {
            const eligibleIds = el.dataset.combinedListingIds.split(',');
            el.classList.toggle('visually-hidden', !eligibleIds.includes(checkedListingInput.value));
          });

          if (this.hasAttribute('data-update-title')) this.updateTitle(checkedListingInput, productInfo);

          this.swiperSlider = this.closest('[data-swiper-general]').dataset.swiperGeneral;
          this.swiperSliderThumbs = this.closest('[data-swiper-general]').dataset.swiperThumbs;
          if (typeof filterSwiperSlides === 'function') filterSwiperSlides(`${variantId}`, window.sectionSwipers[this.swiperSlider], window.sectionSwipers[this.swiperSliderThumbs]);

          if (target.dataset.mediaSrc) {
            this.gallery = this.closest('[data-swiper-general]').querySelector('.product__slider-main').querySelectorAll('.product__media');

            this.gallery.forEach((media, index) => {
              if (media.dataset.srcAttached === target.dataset.mediaSrc) {
                window.sectionSwipers[this.swiperSlider].slideTo(index);
              }
            });
          }

          this.updateMainPrice(checkedListingInput);

          this.stickyATCInfo = document.querySelector('.product__sticky-atc-info');
          this.updateStickyATC(checkedListingInput);
        });
      }

      updateTitle(input, productInfo) {
        const newTitle = input.dataset.productTitle;
        const titleElement = productInfo.querySelector('.product__title-text');
        if (newTitle && titleElement) titleElement.textContent = newTitle;
      }

      updateMainPrice(input) {
        const newPriceHTML = input.nextElementSibling?.querySelector('price-snippet .price')?.innerHTML;
        const productInfoPrices = this.closest('.product__info-wrapper')?.querySelectorAll('[id^="price-"] .price__container > div:first-child') ?? [];
        if (newPriceHTML) {
          productInfoPrices.forEach(price => price.innerHTML = newPriceHTML);
        }

        this.toggleContainerBadges(this.closest('.product__info-wrapper')?.querySelector('[id^="price-"]'));

        const buttonPrice = this.closest('.product__info-wrapper')?.querySelector('[id*="ProductSubmitButton-"] [data-button-price]');
        if (newPriceHTML && buttonPrice) {
          buttonPrice.innerHTML = newPriceHTML;
        }
      }

      syncVariantSelects(target) {
        this.querySelectorAll('variant-selects').forEach((variantSelects) => {
          variantSelects.querySelectorAll('input').forEach((item) => {
            if (item.value === target.value) {
              item.checked = true;
              item.closest('.js-option-container').querySelector('.js-option-value-id').value = item.dataset.optionVariantId;

              const itemPriceElement = item.nextElementSibling?.querySelector('price-snippet [data-current-price]');
              const priceToChange = item.closest('.offer__option').querySelector('.option-info price-snippet .price');
              if (itemPriceElement && priceToChange) priceToChange.innerHTML = itemPriceElement.innerHTML;
            }
          });
        });
      }

      toggleContainerBadges(root) {
        if (!root) return;

        root.querySelectorAll('.price__container').forEach(container => {
          const hasCopiedBadge = container.querySelector(':scope > div:first-child .price__discount-badge');
          const showBadge = this.finalListingValue == 'currentProduct' && !hasCopiedBadge;
          container.querySelectorAll(':scope > .price__discount-badge').forEach(badge => {
            badge.classList.toggle('hidden', !showBadge);
          });
        });
      }

      updateStickyATC(input) {
        if (!this.stickyATCInfo) return;

        const newTitle = input.nextElementSibling?.querySelector('[data-option-title]')?.innerHTML;
        const newPriceHTML = input.nextElementSibling?.querySelector('price-snippet .price')?.innerHTML;
        const newImage = input.nextElementSibling?.querySelector('.option-info img').src;

        const titleElement = this.stickyATCInfo.querySelector('.product__sticky-atc-heading');
        const priceElement = this.stickyATCInfo.querySelector('[data-current-price] .price__container div');
        const imageElement = this.stickyATCInfo.querySelector('img');
        const atcButtonPriceElement = document.querySelector('.product__sticky-atc [data-atc-button-price] price-snippet [data-current-price] .price__container div');

        if (titleElement && newTitle) titleElement.innerHTML = newTitle;
        if (priceElement && newPriceHTML) priceElement.innerHTML = newPriceHTML;
        if (atcButtonPriceElement && newPriceHTML) atcButtonPriceElement.innerHTML = newPriceHTML;
        this.toggleContainerBadges(this.stickyATCInfo);
        this.toggleContainerBadges(document.querySelector('.product__sticky-atc [data-atc-button-price]'));
        if (imageElement && newImage) {
          imageElement.src = newImage;
          imageElement.srcset = newImage;
        }
      }
    }
  );
}